<!-- Pie Chart - Chart.js Implementation -->
<div class="pie-chart-container" #chartContainer>
  <!-- Chart Wrapper -->
  <div class="chart-wrapper">
    <!-- Chart.js Pie Chart -->
    <div class="chart-section">
      <div class="chart-container">
        <canvas baseChart 
          [data]="pieChartData" 
          [type]="pieChartType" 
          [options]="pieChartOptions"
          (chartClick)="onChartSelect($event)"
          (chartHover)="onChartActivate($event)">
        </canvas>
      </div>
    </div>
  </div>

  <!-- Custom Legend - Below Chart -->
  <div class="pie-chart-legend" *ngIf="legend && pieChartData.labels && pieChartData.labels.length > 0">
    <div class="legend-items">
      <div class="legend-item" *ngFor="let label of pieChartData.labels; let i = index">
        <div class="legend-color" 
             [style.background-color]="getLegendColor(i)">
        </div>
        <span class="legend-label">{{ label }}</span>
      </div>
    </div>
  </div>
</div>

